import React, { useState } from 'react';
import { Button } from 'components/shadcn/ui/button';
import HGPrivacyPolicy from '../HGPrivacyPolicy';

const AccountTypeSelector = ({ setAccountType }) => {
    const [openPolicy, setOpenPolicy] = useState(false);

    const selectAccountType = (type) => {
        const cachedAgreement = JSON.parse(
            sessionStorage.getItem('privacyPolicyAccepted')
        );
        if (cachedAgreement) {
            setAccountType(type);
            return;
        }
        sessionStorage.setItem('signupAccountType', type);
        setOpenPolicy(true);
    };

    return (
        <div>
            <p className="text-base text-foreground">
                Please select the type of account you would like to create:
            </p>
            <div className="flex h-[200px] w-full flex-col justify-evenly">
                <Button
                    onClick={() => selectAccountType('customer')}
                    variant="outline"
                    className="font-bold uppercase text-foreground"
                >
                    customer
                </Button>
                <Button
                    onClick={() => selectAccountType('installer')}
                    variant="outline"
                    className="font-bold uppercase text-foreground"
                >
                    installer
                </Button>
                <Button
                    onClick={() => selectAccountType('company')}
                    variant="outline"
                    className="font-bold uppercase text-foreground"
                >
                    company
                </Button>
            </div>
            <HGPrivacyPolicy
                open={openPolicy}
                close={() => setOpenPolicy(false)}
                setAccountType={setAccountType}
            />
        </div>
    );
};

export default AccountTypeSelector;
